import React, { useState, useContext, useEffect } from "react";
import Header from "../Components/Header";
import Siderbar from "../Components/Siderbar";
import JournalSidebar from "../Components/JournalSidebar";
import useSidebarStore from "../zustand-stores/SidebarStore";
import "../css/sidebar.css";

export default function Layout({ children, showHeader = true }) {
  const [openJournalSidebar, setOpenJournalSidebar] = useState(false);
  const { sidebarCollapsed, toggleSidebar, toggleMobileState, sidebarExpanded } = useSidebarStore();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="container-fluid p-0" style={{ height: "100vh" }}>
      <div className="row g-0 h-100">
        <Siderbar setOpenJournalSidebar={setOpenJournalSidebar} onToggleSidebar={toggleSidebar} onMobileClose={() => toggleMobileState(false)} />
        {isMobile && sidebarExpanded && <div className="mobile-sidebar-overlay" onClick={() => toggleMobileState(false)} aria-hidden="true" />}
        <JournalSidebar open={openJournalSidebar} setOpenJournalSidebar={setOpenJournalSidebar} onLinkClick={() => setOpenJournalSidebar(false)} />
        <div className="col">
          <div className={`main-content ${isMobile ? "full-extended" : sidebarCollapsed ? "extended" : ""}`}>
            {showHeader && <Header onSidebarToggle={toggleMobileState} />}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
